export enum OrganizationContext {
  Trader,
  Supplier,
  Consumer,
}
